// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-header {
  background-color: #fff;
  position: sticky;
  top: 0;
  z-index: 1020;
  padding: 10px 20px;
}
.custom-header .container-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.custom-header .container-header .logo-link img {
  height: 40px;
  width: 40px;
}
.custom-header .container-header .hamburger-menu {
  display: none;
  cursor: pointer;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  transition: background-color 0.3s ease;
}
.custom-header .container-header .hamburger-menu .bar {
  width: 25px;
  height: 3px;
  margin: 3px 0;
  background-color: #333;
}
.custom-header .container-header .navbar .nav-list {
  display: flex;
  margin: 0;
  padding: 0;
  list-style: none;
}
.custom-header .container-header .navbar .nav-list .nav-item {
  margin: 0 10px;
}
.custom-header .container-header .navbar .nav-list .nav-item .nav-link {
  display: block;
  padding: 7px;
  text-decoration: none;
  color: #000;
  transition: background-color 0.3s ease, color 0.3s ease;
}
.custom-header .container-header .navbar .nav-list .nav-item .nav-link:hover, .custom-header .container-header .navbar .nav-list .nav-item .nav-link.active {
  background-color: var(--primary-color);
  color: #fff;
}
.custom-header .container-header .navbar .nav-list .nav-item.dropdown {
  position: relative;
}
.custom-header .container-header .navbar .nav-list .nav-item.dropdown .dropdown-menu {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  white-space: nowrap;
  min-width: max-content;
  padding: 0;
  margin: 0;
  list-style: none;
}
.custom-header .container-header .navbar .nav-list .nav-item.dropdown .dropdown-menu .nav-item {
  margin: 0;
}
.custom-header .container-header .navbar .nav-list .nav-item.dropdown .dropdown-menu .nav-item .nav-link {
  padding: 7px;
  color: #000;
}
.custom-header .container-header .navbar .nav-list .nav-item.dropdown .dropdown-menu .nav-item .nav-link:hover, .custom-header .container-header .navbar .nav-list .nav-item.dropdown .dropdown-menu .nav-item .nav-link.active {
  background-color: var(--primary-color);
  color: #fff;
}
.custom-header .container-header .navbar .nav-list .nav-item.dropdown:hover .dropdown-menu {
  display: block;
}
.custom-header .container-header .user-menu {
  margin-left: auto;
  position: relative;
}
.custom-header .container-header .user-menu:hover .dropdown-user-menu {
  display: block !important;
}
.custom-header .container-header .user-menu .mini-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  transition: box-shadow 0.3s ease;
}
.custom-header .container-header .user-menu .mini-avatar:hover {
  box-shadow: 0 0 2px 2px var(--primary-color);
}
.custom-header .container-header .user-menu .dropdown-user-menu {
  display: none;
  position: absolute;
  top: 100%;
  right: 0;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  list-style: none;
}
.custom-header .container-header .user-menu .dropdown-user-menu .nav-item {
  margin: 0;
}
.custom-header .container-header .user-menu .dropdown-user-menu .nav-item button,
.custom-header .container-header .user-menu .dropdown-user-menu .nav-item .file-upload-label {
  display: block;
  padding: 7px;
  background: none;
  border: none;
  color: #000;
  cursor: pointer;
  text-align: left;
  width: 100%;
}
.custom-header .container-header .user-menu .dropdown-user-menu .nav-item button:hover,
.custom-header .container-header .user-menu .dropdown-user-menu .nav-item .file-upload-label:hover {
  background-color: var(--primary-color);
  color: #fff;
}
.custom-header .container-header .user-menu .dropdown-user-menu .nav-item .file-upload-label {
  cursor: pointer;
}
.custom-header .container-header .user-menu.show .dropdown-menu {
  display: block;
}
@media (max-width: 800px) {
  .custom-header .hamburger-menu {
    display: block !important;
  }
  .custom-header .navbar {
    display: none;
  }
  .custom-header .navbar .nav-list {
    flex-direction: column;
    position: absolute;
    top: 60px;
    left: 0;
    width: 60%;
    background-color: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    padding: 10px 0;
  }
  .custom-header .navbar .nav-list .nav-item {
    width: auto;
    text-align: center;
    border-bottom: 1px solid #ddd;
    box-sizing: border-box;
    margin: 0 !important;
  }
  .custom-header .navbar .nav-list .nav-item .nav-link {
    padding: 10px;
    width: 100%;
  }
  .custom-header .navbar .nav-list .nav-item .nav-link:last-child {
    border-bottom: none;
  }
  .custom-header .navbar .nav-list .nav-item.dropdown {
    position: relative;
  }
  .custom-header .navbar .nav-list .nav-item.dropdown .dropdown-menu {
    position: absolute;
    left: 0;
    top: 100%;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    z-index: 1060;
    padding: 10px 0;
    width: auto;
    box-sizing: border-box;
  }
  .custom-header .navbar .nav-list .nav-item.dropdown .dropdown-menu .nav-item {
    width: 100%;
  }
  .custom-header .navbar .nav-list .nav-item.dropdown .dropdown-menu .nav-item .nav-link {
    padding: 10px;
  }
  .custom-header .hamburger-menu:hover + .navbar,
  .custom-header .navbar:hover {
    display: flex !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/header.scss"],"names":[],"mappings":"AAKA;EACE,sBAAA;EACA,gBAAA;EACA,MAAA;EACA,aAAA;EACA,kBAAA;AAJF;AAME;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAJJ;AAOM;EACE,YAAA;EACA,WAAA;AALR;AASI;EACE,aAAA;EACA,eAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,sCAAA;AAPN;AASM;EACE,WAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AAPR;AAYM;EACE,aAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AAVR;AAYQ;EACE,cAAA;AAVV;AAYU;EACE,cAAA;EACA,YAAA;EACA,qBAAA;EACA,WAAA;EACA,uDAAA;AAVZ;AAYY;EAEE,sCA7DE;EA8DF,WAAA;AAXd;AAeU;EACE,kBAAA;AAbZ;AAeY;EACE,aAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,sBAxEM;EAyEN,kBAAA;EACA,uCAzEI;EA0EJ,mBAAA;EACA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;AAbd;AAec;EACE,SAAA;AAbhB;AAegB;EACE,YAAA;EACA,WAAA;AAblB;AAekB;EAEE,sCA5FJ;EA6FI,WAAA;AAdpB;AAoBY;EACE,cAAA;AAlBd;AAyBI;EACE,iBAAA;EACA,kBAAA;AAvBN;AA0BQ;EACE,yBAAA;AAxBV;AA4BM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;AA1BR;AA4BQ;EACE,4CAAA;AA1BV;AA8BM;EACE,aAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,sBApIY;EAqIZ,kBAAA;EACA,uCArIU;EAsIV,gBAAA;AA5BR;AA8BQ;EACE,SAAA;AA5BV;AA8BU;;EAEE,cAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AA5BZ;AA8BY;;EACE,sCA1JE;EA2JF,WAAA;AA3Bd;AA+BU;EACE,eAAA;AA7BZ;AAkCM;EACE,cAAA;AAhCR;AAqCE;EACE;IACE,yBAAA;EAnCJ;EAwCE;IACE,aAAA;EAtCJ;EAwCI;IACE,sBAAA;IACA,kBAAA;IACA,SAAA;IACA,OAAA;IACA,UAAA;IACA,sBAAA;IACA,uCAzLU;IA0LV,eAAA;EAtCN;EAwCM;IACE,WAAA;IACA,kBAAA;IACA,6BAAA;IACA,sBAAA;IACA,oBAAA;EAtCR;EAwCQ;IACE,aAAA;IACA,WAAA;EAtCV;EAwCU;IACE,mBAAA;EAtCZ;EA0CQ;IACE,kBAAA;EAxCV;EA0CU;IACE,kBAAA;IACA,OAAA;IACA,SAAA;IACA,sBApNM;IAqNN,kBAAA;IACA,uCArNI;IAsNJ,aAAA;IACA,eAAA;IACA,WAAA;IACA,sBAAA;EAxCZ;EA0CY;IACE,WAAA;EAxCd;EA0Cc;IACE,aAAA;EAxChB;EAiDE;;IAEF,wBAAA;EA/CA;AACF","sourcesContent":["$primary-color: var(--primary-color);\n$background-color: var(--background-color);\n$dropdown-bg-color: #fff;\n$dropdown-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n\n.custom-header {\n  background-color: #fff;\n  position: sticky;\n  top: 0;\n  z-index: 1020;\n  padding: 10px 20px; // Add padding for better spacing on mobile\n\n  .container-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between; // Space out logo and user menu\n\n    .logo-link {\n      img {\n        height: 40px;\n        width: 40px;\n      }\n    }\n\n    .hamburger-menu {\n      display: none; // Hidden by default for desktop\n      cursor: pointer;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      width: 30px; // Adjust size for better tap area\n      height: 30px;\n      transition: background-color 0.3s ease;\n\n      .bar {\n        width: 25px;\n        height: 3px;\n        margin: 3px 0; // Adjust margin for closer bars\n        background-color: #333;\n      }\n    }\n\n    .navbar {\n      .nav-list {\n        display: flex;\n        margin: 0;\n        padding: 0;\n        list-style: none;\n\n        .nav-item {\n          margin: 0 10px;\n\n          .nav-link {\n            display: block;\n            padding: 7px;\n            text-decoration: none;\n            color: #000;\n            transition: background-color 0.3s ease, color 0.3s ease;\n\n            &:hover,\n            &.active {\n              background-color: $primary-color;\n              color: #fff;\n            }\n          }\n\n          &.dropdown {\n            position: relative;\n\n            .dropdown-menu {\n              display: none;\n              position: absolute;\n              top: 100%;\n              left: 0;\n              background-color: $dropdown-bg-color;\n              border-radius: 8px;\n              box-shadow: $dropdown-shadow;\n              white-space: nowrap;\n              min-width: max-content;\n              padding: 0;\n              margin: 0;\n              list-style: none;\n\n              .nav-item {\n                margin: 0;\n\n                .nav-link {\n                  padding: 7px;\n                  color: #000;\n\n                  &:hover,\n                  &.active {\n                    background-color: $primary-color;\n                    color: #fff;\n                  }\n                }\n              }\n            }\n\n            &:hover .dropdown-menu {\n              display: block;\n            }\n          }\n        }\n      }\n    }\n\n    .user-menu {\n      margin-left: auto;\n      position: relative;\n\n      &:hover {\n        .dropdown-user-menu {\n          display: block !important;\n        }\n      }\n\n      .mini-avatar {\n        width: 40px;\n        height: 40px;\n        border-radius: 50%;\n        cursor: pointer;\n        transition: box-shadow 0.3s ease;\n\n        &:hover {\n          box-shadow: 0 0 2px 2px $primary-color;\n        }\n      }\n\n      .dropdown-user-menu {\n        display: none;\n        position: absolute;\n        top: 100%;\n        right: 0;\n        background-color: $dropdown-bg-color;\n        border-radius: 8px;\n        box-shadow: $dropdown-shadow;\n        list-style: none;\n\n        .nav-item {\n          margin: 0;\n\n          button,\n          .file-upload-label {\n            display: block;\n            padding: 7px;\n            background: none;\n            border: none;\n            color: #000;\n            cursor: pointer;\n            text-align: left;\n            width: 100%;\n\n            &:hover {\n              background-color: $primary-color;\n              color: #fff;\n            }\n          }\n\n          .file-upload-label {\n            cursor: pointer;\n          }\n        }\n      }\n\n      &.show .dropdown-menu {\n        display: block;\n      }\n    }\n  }\n\n  @media (max-width: 800px) {\n    .hamburger-menu {\n      display: block !important; // Show hamburger menu on mobile\n\n\n    }\n\n    .navbar {\n      display: none; // Скрыть навбар по умолчанию на мобильных устройствах\n\n      .nav-list {\n        flex-direction: column;\n        position: absolute;\n        top: 60px;\n        left: 0;\n        width: 60%;\n        background-color: #fff;\n        box-shadow: $dropdown-shadow;\n        padding: 10px 0;\n\n        .nav-item {\n          width: auto;\n          text-align: center;\n          border-bottom: 1px solid #ddd;\n          box-sizing: border-box;\n          margin: 0 !important;\n\n          .nav-link {\n            padding: 10px;\n            width: 100%;\n\n            &:last-child {\n              border-bottom: none;\n            }\n          }\n\n          &.dropdown {\n            position: relative;\n\n            .dropdown-menu {\n              position: absolute;\n              left: 0;\n              top: 100%;\n              background-color: $dropdown-bg-color;\n              border-radius: 8px;\n              box-shadow: $dropdown-shadow;\n              z-index: 1060;\n              padding: 10px 0;\n              width: auto;\n              box-sizing: border-box;\n\n              .nav-item {\n                width: 100%;\n\n                .nav-link {\n                  padding: 10px;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .hamburger-menu:hover + .navbar,\n.navbar:hover {\n  display: flex !important; // Оставить меню открытым при наведении курсора на гамбургер или на меню\n}\n\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
